import { useModal } from '../contexts';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';

interface Props {
  onConfirm: () => void;
}

function SignatureRequestModalRevertOverride(props: Props) {
  const { closeModal } = useModal();
  const { t } = useTranslation();

  function handleConfirm() {
    props.onConfirm();
    closeModal();
  }

  return (
    <Modal
      title={t("Revert to Default")}
      subtitle={t("The personalized content for this recipient will be removed and they will receive the default signature request email.")}
      secondaryButtonProps={{ text: t("Cancel"), onClick: closeModal }}
      primaryButtonProps={{ text: t("Revert"), onClick: handleConfirm }}
      size='sm'
    />
  );
}

export default SignatureRequestModalRevertOverride;
